import { ApiService } from "./api.service";
export default class AutoMatedCreateService extends ApiService {
  namespace = "create-automated-task";
  relations =
    "?expand=responsibleSimple,peopleSimple,files,files.file,files.file.commentsCount,completedByName";
  icon = "TaskList";
  
  singular = this.terminology.task.singular;
  plural = this.terminology.task.plural;
  vowel = this.terminology.task.vowel;
  name = this.singular;
  favicon = "ClipboardWithTasks";
  Width = 890;
  DOMAIN = 305;
  action = "action";
}
